import { Button } from '@ctw/shared/components/button';
import { ButtonGroup } from '@ctw/shared/components/button-group';
import { useZuiContext } from '@ctw/shared/context/zui-provider';
import { hrefIsActive, pathWithParameters } from '@ctw/shared/utils/url';
import { useMemo } from 'react';

export const DemographicsTabs = () => {
  const { navigate, pathname } = useZuiContext();

  const isEmbedded = window.self !== window.top;

  const tabs = useMemo(
    () => [
      {
        id: 'contact-information',
        label: 'Contact Information',
        href: 'contact-information',
      },
      {
        id: 'sources',
        label: 'Sources',
        href: 'sources',
      },
      {
        id: 'zus-records',
        label: 'Zus Records',
        href: 'zus-records',
        hidden: isEmbedded,
      },
    ],
    [isEmbedded],
  );

  const selectedTab = useMemo(
    () => tabs.find((tab) => hrefIsActive({ pathname, href: tab.href })),
    [pathname, tabs],
  );

  // `navigate` re-joins an absolute path onto the app's base path (e.g. `/v1` in the embedded
  // ZAP), so that base path must be stripped from `pathname` first, or it ends up doubled.
  const basePathStrippedPathname = pathWithParameters(pathname, {});
  const patientRouteBase = basePathStrippedPathname.slice(
    0,
    basePathStrippedPathname.lastIndexOf('/'),
  );

  return (
    <ButtonGroup>
      {tabs
        .filter((tab) => !tab.hidden)
        .map((tab) => (
          <Button
            key={tab.id}
            testId={`${tab.id}-tab`}
            type="button"
            variant={selectedTab?.id === tab.id ? 'primary' : 'secondary'}
            telemetryInteractionName="tab_navigation_button_click"
            telemetryContext={{ tabName: tab.label }}
            onClick={() => {
              navigate(`${patientRouteBase}/${tab.href}`);
            }}
          >
            {tab.label}
          </Button>
        ))}
    </ButtonGroup>
  );
};
